import { pdf } from '@react-pdf/renderer';
import ArrearsSeventhPurePDF from './ArrearsSeventhResultPDF';  // Your React PDF component
import generateExcelFile from './xlsxArrearsSeventh';  // Your ExcelJS-based Excel generation script

export async function sendEmail(result, info) {
  try {
    const formatDate = (date) => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    };
    const formattedDate = formatDate(new Date());

    // Generate PDF Blob using React PDF
    const pdfBlob = await pdf(<ArrearsSeventhPurePDF result={result} info={info} />).toBlob();

    // Generate Excel Blob using ExcelJS
    const excelBlob = await generateExcelFile(result, info);  // Get the Excel Blob from ExcelJS

    // Email Content with Elegant Styling
    const text = `Dear ${info.employeeName},

Thank you for submitting your form at Himanshu Salary Corner. We have successfully processed your request, and your result is now available.

Please find attached a PDF document containing your result according to your form submission details. Kindly review the document, and if you have any questions or require further assistance, feel free to reach out to us.

Company Details:
📍 Himanshu Salary Corner
🏢 159 Guruwar Peth, Satara
📞 +91 9604966776

We appreciate your trust in our services and look forward to assisting you again in the future.

Best regards,
Himanshu Salary Corner
📩 admin@himanshusalarycorner.in
🌐 himanshusalarycorner.in
    `;

    // Create FormData to send the Blob to backend
    const formData = new FormData();
    formData.append('pdf', pdfBlob, `DA_Arrears_${info.employeeName}.pdf`);
    formData.append('excel', excelBlob, `DA_Arrears_${info.employeeName}.xlsx`); // Append Excel Blob
    
    formData.append('to', info.email);
    formData.append('subject', 'Statement of D.A. & H.R.A. Payable Due to D.A. Rate Revision');
    formData.append('text', text);

    // Send email request to the backend
    const emailResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/send-email`, {
      method: 'POST',
      body: formData,
    });

    const emailResult = await emailResponse.json();
    if (!emailResponse.ok) {
      throw new Error(emailResult.error || 'Failed to send email');
    }

  } catch (error) {
    // Log the error to understand what went wrong
    console.error('Error sending email:', error);
  }
}
